/**
 * Landing-page event tracker — fire-and-forget vers /api/landing-events.
 *
 * Allowed events (whitelist côté backend) :
 *   page_view · scroll_50 · click_calculateur · click_cta_sticky ·
 *   click_cta_primary · start_form · submit_form · poste_select · roi_generated
 *
 * Toujours non-bloquant : tracking failure ne casse JAMAIS le flow utilisateur.
 */
import { getBackendUrl } from './api';

const FP_KEY = 'tp_landing_fp';

const getFingerprint = () => {
  try {
    let fp = localStorage.getItem(FP_KEY);
    if (!fp) {
      fp = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(FP_KEY, fp);
    }
    return fp;
  } catch {
    return null;
  }
};

const sentOnce = new Set();

/**
 * Émet un event landing.
 * @param {string} event   — type d'événement (whitelisted backend)
 * @param {object} [opts]  — { page, meta, dedupe (default true) }
 */
export const trackLanding = (event, opts = {}) => {
  if (typeof window === 'undefined') return;
  const page = opts.page || window.location.pathname;
  const dedupe = opts.dedupe !== false;
  const key = `${event}:${page}:${JSON.stringify(opts.meta || {})}`;
  if (dedupe && sentOnce.has(key)) return;
  sentOnce.add(key);

  const body = JSON.stringify({
    event,
    page,
    fingerprint: getFingerprint(),
    meta: opts.meta || {},
  });

  const url = `${getBackendUrl()}/api/landing-events`;
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* never break user flow over tracking */
  }
};
